import React from 'react';
import './scss/export-header.scss';
interface ExportHeaderProps {
  label: string;
}
const ExportHeader = ({ label }: ExportHeaderProps) => (
  <header className="pdf-layout__header">
    <img
      src="https://cdn.thomasnet.com/img/thomas-xometry-logo--white-nocaption.svg"
      style={{ maxHeight: '2.75rem' }}
    />
    {label && <h1 className="pdf-layout__header-title">{label}</h1>}
  </header>
);

ExportHeader.defaultProps = {
  label: 'Enter Label'
};

export default ExportHeader;
